'use strict'

import { gsap } from "gsap";

// gsap.registerPlugin(ScrollTrigger) 

const navbar = document.querySelector(".nav");
const header = document.querySelector(".header")

let lastScrollY = window.scrollY;
let isAnchorScrolling = false;

// Clic sur une ancre
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener("click", () => {
        isAnchorScrolling = true;

        // On laisse le scroll de l'ancre se faire
        setTimeout(() => {
            isAnchorScrolling = false;
            lastScrollY = window.scrollY;
        }, 800);
    });
});

window.addEventListener("scroll", () => {
    const currentScrollY = window.scrollY;
    const headerBottom = header.getBoundingClientRect().bottom;

    // Si le scroll vient d'une ancre → ne rien faire
    if (isAnchorScrolling) {
        lastScrollY = currentScrollY;
        return;
    }

    // Header encore visible
    if (headerBottom > 100) {
        navbar.classList.remove("nav--hidden");
    }

    // Header passé + scroll vers le bas
    else if (currentScrollY > lastScrollY) {
        navbar.classList.add("nav--hidden");
    }

    // Scroll vers le haut
    else if (currentScrollY < lastScrollY) {
        navbar.classList.remove("nav--hidden");
    }

    lastScrollY = currentScrollY;
});